<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon color="white" size="28px" v-on="on" @click="menuAjuda = !menuAjuda">mdi-help-circle-outline</v-icon>
      </template>
      <span>Ajuda</span>
    </v-tooltip>
    <v-card v-if="menuAjuda" min-width="350" max-width="350" class="menu-ajuda">
      <v-card-title class="secondary titulos font-weight-bold" style="color: black">
        Ajuda
        <v-spacer></v-spacer>
        <v-icon @click="menuAjuda = false">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="px-0  pb-0 mb-0">
        <v-row class="text-left" style="color: black" no-gutters>
          <v-expansion-panels accordion multiple focusable>
            <v-expansion-panel>
              <v-expansion-panel-header class="titulos">Como criar um modelo de assinatura?</v-expansion-panel-header>
              <v-expansion-panel-content>
                <ol class="listas pl-3">
                  <li>Selecione uma organização ou grupo.</li>
                  <li>Caso selecione um grupo, será necessário selecionar os usuários no qual deseja aplicar a assinatura de e-mail.</li>
                  <li>Arraste os campos no qual dejesa que sua assinatura de e-mail contenha para o campo 'Modelo de assinatura'.</li>
                </ol>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header class="titulos">Como aplicar o modelo de assinatura?</v-expansion-panel-header>
              <v-expansion-panel-content>
                <ul class="listas pl-4">
                  <li>Clique em 'Aplicar' para que o modelo criado seja aplicado instantaneamente.</li>
                  <li>Clique em 'Agendar' para aplicar o modelo criado por um período de tempo.</li>
                  <li>Clique em 'Salvar' para apenas guardar o modelo criado e usá-lo quando desejar.</li>
                </ul>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-card-text>
    </v-card>
      
  </div>
</template>

<script>
export default {
  data(){
    return{
      menuAjuda: false
    }
  }
};
</script>

<style scoped>
.menu-ajuda {
  top: 57px;
  right: 0px; 
  position: absolute;
}
</style>